module.exports = __webpack_public_path__ + "static/img/wechat-open.0b35844.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/wechat-open.png
// module id = 1swP
// module chunks = 1